module.exports = __webpack_public_path__ + "img/1.75904282.jpg";